import { MouseEvent } from 'react';

import { DropdownItem } from '../../atoms/SelectMenu';
import { ContactData } from '../../molecules/Contact';
import { AddressDataType } from '../../organisms/StructureAddress';

export interface ContactDataType {
  id?: number;
  contactType?: string;
  contactName?: string;
  organization?: string;
  phone1?: string;
  phone2?: string;
  email?: string;
  notes?: string;
  isActive?: boolean;
}

export interface StructureAddressContactLayoutProps {
  heading: string;
  isAddress: boolean;
  isOneAddress?: boolean;
  renderNotes: boolean;
  contactData?: ContactData;
  contactType: DropdownItem[];
  addressDataset: AddressDataType[];
  contactDataset?: ContactDataType[];
  contactFormData: ContactData[];
  addressFormData: AddressDataType[];
  editContactFormData?: ContactDataType;
  editAddressFormData?: AddressDataType;
  enableContactNumber?: boolean;
  /**
   * In-progress rows in the address/contact editor: `{ value, prevValue }`,
   * where `prevValue` is what Cancel restores. Deliberately left open — the
   * drafts hold partially-filled records and are written back into
   * `addressFormData`/`contactFormData` as if complete, so a faithful type here
   * needs that write-back reworked first, across all seven consumers.
   */
  /* eslint-disable @typescript-eslint/no-explicit-any */
  addressForm?: any[];
  contactForm?: any[];
  setAddressForm?: (value: any[]) => void;
  setContactForm?: (value: any[]) => void;
  /* eslint-enable @typescript-eslint/no-explicit-any */
  onClickContactEdit?: (event: MouseEvent<HTMLButtonElement>, index: number) => void;
  onClickContactDelete?: (event: MouseEvent<HTMLButtonElement>, index: number) => void;
  onClickAddressEdit?: (event: MouseEvent<HTMLButtonElement>, index: number) => void;
  onClickAddressDelete?: (event: MouseEvent<HTMLButtonElement>, index: number) => void;
  onStructureAddressChange: (value: AddressDataType[]) => void;
  onContactChange?: (value: ContactData[]) => void;
  handleAddressCreate?: (index: number) => void;
  handleContactCreate?: (index: number) => void;
  addFormEnabledByDefault?: boolean;
  enableAddressContactFields?: boolean;
  hideAddressType?: boolean;
  hasContractAddressEditPermission?: boolean;
  /**
   * Drops the card chrome so the layout can sit directly inside a `Panel`
   * without a second border around it. The heading is also suppressed — the
   * panel already carries one.
   */
  flush?: boolean;
  /** Drops the internal heading for callers that already title the block from
   *  their own card chrome. The Add button keeps its position. */
  hideHeading?: boolean;
  /**
   * A suburb on the saved address that matches no known region, marked in the
   * address line so the reader can see *which* word is the problem. Paired with
   * `StructureZoneBanner`, which offers the alternatives.
   */
  unmatchedSuburb?: string;
}

export const EmptyMainAddress = {
  addressType: 'Main',
  name: '',
  traditionalPlaceName: '',
  line1: '',
  line2: '',
  suburb: '',
  city: '',
  stateName: '',
  postCode: '',
  countryName: '',
  isActive: true,
};

export const EmptyMainContact = {
  contactType: 'Main',
  contactName: '',
  organization: '',
  phone1: '',
  phone2: '',
  email: '',
  notes: '',
  isActive: true,
};
